import { useEffect, useState } from "react";
import { getMarketplaces } from "../api";
import {
  Badge,
  Button,
  Code,
  Container,
  Group,
  Table,
  Title,
  Tooltip,
} from "@mantine/core";
import { Link } from "wouter";
import { IconPlus } from "@tabler/icons-react";
import Timeago from "../../../Boilerplate/_Shared/Timeago";
import { marketplaceSyncBadge } from "./marketplaceSync";

export default function MarketplaceList() {
  const [marketplaces, setMarketplaces] = useState([]);

  useEffect(() => {
    getMarketplaces().then((data) => {
      setMarketplaces(data);
    });
  }, []);

  return (
    <Container size="xl">
      <Group justify="space-between" align="center">
        <Title order={1}>Marketplaces</Title>

        <Button
          leftSection={<IconPlus />}
          variant="default"
          component={Link}
          to={"/marketplaces/create"}
        >
          Add Marketplace
        </Button>
      </Group>

      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Id</Table.Th>
            <Table.Th>Name</Table.Th>
            <Table.Th>Configured</Table.Th>
            <Table.Th>Last successful update</Table.Th>
            <Table.Th>Sync</Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {marketplaces.map((marketplace) => {
            const sync = marketplaceSyncBadge(marketplace);
            return (
              <Table.Tr key={marketplace.id}>
                <Table.Td>
                  <Code>{marketplace.id}</Code>
                </Table.Td>
                <Table.Td>{marketplace.name}</Table.Td>
                <Table.Td>
                  {marketplace.isConfigured ? (
                    <Badge color="teal">Yes</Badge>
                  ) : (
                    <Badge color="orange">No</Badge>
                  )}
                </Table.Td>
                <Table.Td>
                  {marketplace.lastSuccessfulUpdateAt ? (
                    <Tooltip
                      label={new Date(
                        marketplace.lastSuccessfulUpdateAt
                      ).toLocaleString()}
                    >
                      <span>
                        <Timeago date={marketplace.lastSuccessfulUpdateAt} />
                      </span>
                    </Tooltip>
                  ) : (
                    "—"
                  )}
                </Table.Td>
                <Table.Td>
                  <Tooltip
                    label={marketplace.lastUpdateError || undefined}
                    disabled={!marketplace.lastUpdateError}
                  >
                    <Badge color={sync.color}>{sync.label}</Badge>
                  </Tooltip>
                </Table.Td>
                <Table.Td>
                  <Group>
                    <Link to={`/marketplaces/${marketplace.id}`}>Details</Link>
                    <Link to={`/marketplaces/${marketplace.id}/mapping`}>
                      Mapping
                    </Link>
                    <Link to={`/marketplaces/${marketplace.id}/types/tree`}>
                      Types
                    </Link>
                  </Group>
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </Container>
  );
}
